import React, { useState } from "react";
import { Text, TouchableOpacity, StyleSheet, FlatList } from "react-native";
import { Input } from "react-native-elements";

const MemoScreen = () => {
  const [time, setTime] = useState("");
  const [hide3, setHide3] = useState(false);
  const [hide, setHide] = useState(false);
  const [hide2, setHide2] = useState(false);
  const [number, setNumber] = useState("");
  const [display, setDisplay] = useState("");
  const [answer, setAnswer] = useState("");
  const onChange = () => {
    setHide(true);
    setHide2(true);
    setHide3(false);
    var max = Math.pow(10, number);
    var min = Math.pow(10, number - 1);
    var num = Math.floor(Math.random() * (max - min) + min);
    setDisplay(num);
    setAnswer(num);
    var count = 0;
    var myVar = setInterval(() => {
      if (count == -1) {
        var max = Math.pow(10, number);
        var min = Math.pow(10, number - 1);
        var num = Math.floor(Math.random() * (max - min) + min);
        setDisplay(num);
        setAnswer(num);
        count++;
      } else {
        clearInterval(myVar);
        setHide2(true);
        setHide(true);
        setDisplay("");
        //  alert("OOPs Times Up!!");
      }
    }, parseInt(time * 1000));
  };

  const onNext = () => {
    setHide3(true);
  };
  return (
    <>
      {!hide && (
        <>
          <Input
            keyboardType={"number-pad"}
            label="Enter Digit"
            value={number}
            onChangeText={(newValue) => setNumber(newValue)}
          />
          <Input
            keyboardType={"number-pad"}
            label="Time in seconds"
            value={time}
            onChangeText={(newValue) => setTime(newValue)}
          />
          <TouchableOpacity style={styles.button} onPress={onChange}>
            <Text>Lets Start</Text>
          </TouchableOpacity>
        </>
      )}
      {hide2 && (
        <>
          <Text style={styles.text}>{display}</Text>
          <TouchableOpacity style={styles.button} onPress={() => onNext()}>
            <Text>Check Answer</Text>
          </TouchableOpacity>
          {hide3 && (
            <>
              <Text style={styles.text}>{answer}</Text>
            </>
          )}
          <TouchableOpacity style={styles.button} onPress={onChange}>
            <Text>Start Again</Text>
          </TouchableOpacity>
        </>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  button: {
    alignItems: "center",
    borderColor: "black",
    borderWidth: 2,
    borderRadius: 180,
    padding: 10,
    margin: 10,
  },
  text: {
    textAlign: "center",
    fontSize: 30,
  },
  buttonDanger: {
    alignItems: "center",
    borderColor: "red",
    borderWidth: 5,
    borderRadius: 180,
    padding: 10,
    margin: 10,
  },
});

export default MemoScreen;
